export const COMPANY_NAME = 'IN6';
